import { usePage } from "@inertiajs/react";
import { Alert, Button, Stack } from "@mui/material";
import HttpStatus from "http-status-codes";
import { useState } from "react";

import useFetch, { FailureHandler } from "../../../hooks/useFetch";
import { parseFormErrors } from "../../../lib/form";
import Input, { InputType } from "../Input";

const LoginCodeForm = ({
  codeResponse,
  disabled,
  onSuccess,
}: {
  codeResponse: Record<string, string>;
  disabled?: boolean;
  onSuccess: () => void;
}) => {
  const { baseUrl } = usePage().props;
  const [code, setCode] = useState("");
  const [errors, setErrors] = useState<Record<string, string[]>>({});
  const handleFailure: FailureHandler = ({ json, response }) => {
    if (response?.status === HttpStatus.UNPROCESSABLE_ENTITY) {
      setErrors(parseFormErrors(json, ["code"]));
    }
  };
  const [put, { error, loading }] = useFetch(
    `${baseUrl}/email_authentication`,
    {
      method: "PUT",
      onSuccess,
      onFailure: handleFailure,
    },
  );

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        put({
          nopassword_verification: { ...codeResponse, code },
        });
      }}
    >
      <Stack spacing={1}>
        <Input
          autoFocus
          required
          error={errors.code?.[0]}
          label="Voer de code in die we je hebben gemaild"
          name="code"
          placeholder="123456"
          type={InputType.Number}
          value={code}
          onChange={(e) => setCode(e.target.value as string)}
        />
      </Stack>
      {error && (
        <Alert severity="error" sx={{ marginTop: "1em" }}>
          {error}
        </Alert>
      )}
      <Stack direction="row" justifyContent="end">
        <Button
          loading={loading || disabled}
          sx={{ marginTop: "1em" }}
          type="submit"
          variant="contained"
        >
          Verstuur
        </Button>
      </Stack>
    </form>
  );
};

export default LoginCodeForm;
